import React from 'react';
import { Card } from 'react-bootstrap';
import '../styles/SectionCard.css';
import { useLanguage } from "../LanguageContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify } from '@fortawesome/free-brands-svg-icons';
import '../styles/reference.css'

const Reference = ({ id, title, content }) => {
    const { translations } = useLanguage();
    return (
        <Card className="section-card" id={id}>
            <Card.Body>
                <Card.Title>
                    <h1>{translations.reference.title}</h1>
                </Card.Title>
                <Card.Text>
                    <div>
                        {translations.reference.description}
                    </div>
                    <div>
                        <iframe
                            className="spotify-iframe"
                            src="https://open.spotify.com/embed/playlist/3oMypLdAzf0FCWW2iFghLC?utm_source=generator&theme=0"
                            frameBorder="0"
                            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                            loading="lazy"
                            width="100%"
                            height="380"
                            style={{border: "none"}}
                            referrerPolicy="no-referrer"
                        />
                    </div>

                    <div className="spotify-link">
                        <a href="https://open.spotify.com/playlist/3oMypLdAzf0FCWW2iFghLC?si=a7d438d868d241e9"
                           target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faSpotify} size="2x"/> {/* Adjust size as needed */}
                        </a>
                    </div>

                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Reference;